import { createContext, useContext, useState } from "react";
import { translations } from "@/translations";
import { serverMessagesTr } from "@/translations/serverMessages";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("wms_lang") || "en");

  const t = (key, vars = {}) => {
    let str = translations[lang]?.[key] || translations["en"]?.[key] || key;
    Object.entries(vars).forEach(([k, v]) => { str = str.split(`{{${k}}}`).join(String(v)); });
    return str;
  };

  // A rule message from the backend, in the chosen language when it has a translation.
  const tServer = (message) => (lang === "tr" && serverMessagesTr[message]) || message;

  const toggle = () => {
    const next = lang === "en" ? "tr" : "en";
    setLang(next);
    localStorage.setItem("wms_lang", next);
  };

  return <LangContext.Provider value={{ lang, t, tServer, toggle }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
